import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const EmptyContent = styled.div`
  display: flex;
  min-width: 350px;
  padding: 40px 40px 80px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const EmojiWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  padding: 0 5px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.5px;
`;

export const TitleWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const DescriptionWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
